export default __webpack_public_path__ + "static/media/ktd_layout.ba48b520.jpg";